import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptChairmanNewAndOldStats } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import CardDashboardStatGroup from '@components/card/CardDashboardStatGroup'
import { Num, ThY } from '@utils/utils'
import Stat from '@components/chart/Stat'
import Chart from 'react-google-charts'
import { ColumnChartOptions } from '@components/chart/setting'

const ChairmanNewAndOldStats = ({ title, data }: { title: string; data: IResponseOptChairmanNewAndOldStats }) => {
  const options = ColumnChartOptions('มูลค่าโครงการ', 'ปีงบประมาณ')
  const chartData = [
    [
      'ปีงบประมาณ',
      'ประธานโครงการเก่า',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ประธานโครงการใหม่',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
    ],
    ...data.map((item) => {
      const row: (string | number | null)[] = [String(ThY(item.budget_year))]
      const factors: Partial<Record<keyof IResponseOptChairmanNewAndOldStats[number], string>> = {
        total_old_chairmans: 'ประธานโครงการเก่า',
        total_new_chairmans: 'ประธานโครงการใหม่',
      }
      ;(Object.keys(factors) as (keyof IResponseOptChairmanNewAndOldStats[number])[]).forEach((factor) => {
        row.push(parseFloat(String(item[factor])))
        row.push(Num(item[factor]))
        row.push(`<div style="padding:8px; width: 280px">
        <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
        <strong>${factors[factor]}</strong><br/>
        จำนวนประธานโครงการ : ${Num(item[factor])} คน<br/>
      </div>`)
      })

      return row
    }),
  ]

  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      {data.map((result, index) => {
        return (
          <CardDashboardStatGroup key={result.budget_year}>
            <Stat w={150} label={index > 0 ? '' : 'ปีงบประมาณ'} value={ThY(result.budget_year)} />
            <Stat
              w={250}
              label={index > 0 ? '' : 'จำนวนประธานโครงการทั้งหมด'}
              value={Num(result.total_chairmans)}
              unit="คน"
              diff={result.total_chairmans_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนประธานโครงการเก่า'}
              value={Num(result.total_old_chairmans) + ` (${result.percentage_old_chairmans}%)`}
              unit="คน"
              diff={result.total_old_chairmans_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนประธานโครงการใหม่'}
              value={Num(result.total_new_chairmans) + ` (${result.percentage_new_chairmans}%)`}
              unit="คน"
              diff={result.total_new_chairmans_diff}
            />
          </CardDashboardStatGroup>
        )
      })}
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default ChairmanNewAndOldStats
